// プレミアム広告以外用
import { connect } from 'react-redux';

import { Page } from '../../../../common/store/interface/Page';
import { getTypeTagByCategory } from '../modules/YadsPremium';
import { IGlobalNavigationState } from '../../store/globalNavigation';
import { IYadsState } from '../../../../common/store/common/yads';
import { IPageDataState } from '../../store/pageData';
import Component from '@/public/template/pc/common/components/js/modules/Yads';

interface Props {
  readonly page?: Page;
  readonly typeTag?: string;
}

interface IStates {
  yads?: IYadsState;
  globalNavigation: IGlobalNavigationState;
  pageData: IPageDataState;
}

// dsとparentElementはprops渡しとする
const mapStateToProps = (state: IStates, ownProps: Props) => {
  const page = ownProps.page || null;
  return {
    typeTag: ownProps.typeTag ?? getTypeTagByCategory(page, state.globalNavigation.currentCategory),
    spaYadsUpdateCount: state.yads?.spaYadsUpdateCount,
    shannonId: state.pageData.yads.shannonId,
    categoryId: state.pageData.yads.categoryId
  };
};

/** @deprecated 非同期タグを利用しないYadsNewNormalに移行すること */
export default connect(mapStateToProps, {})(Component);
